var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    attrs: { type: "text", name: _vm.name },
    domProps: { value: _vm.value }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }